/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
  }
});

document.getElementById("add-signature-btn").onclick = async function() {
  try {
    const email = Office.context.mailbox.userProfile.emailAddress;
    const formData = new FormData();
    formData.append('module', 'signatures');
    formData.append('action', 'gethtml');
    formData.append('email', email);

    const response = await fetch("https://backendnovusid.signid.net/service.php", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const signatureHtml = await response.text();
      Office.context.mailbox.item.body.setSelectedDataAsync(
        signatureHtml,
        { coercionType: Office.CoercionType.Html }
      );
    } else {
      alert(`İmza alınamadı. Sunucu hatası: ${response.status}`);
    }
  } catch (error) {
    alert("Bir hata oluştu: " + error);
  }
};
